import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "table"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  width: "50%"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = {
  key: 0,
  class: "px-2"
};
import { onMounted, reactive, computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useMaxioSubscriptionStore } from './useMaxioSubscriptionStore.js';
import { formatCurrency } from '@/services/utils.js';
import { useExportUtilities } from '@/composables/useExportUtilities.js';
export default {
  __name: 'MaxioSubscriptionSummary',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    subscription: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const maxioCompanySubscriptionStore = useMaxioSubscriptionStore();
    const {
      formatDate
    } = useExportUtilities();

    // Get features from the MeStore
    const meStore = useMeStore();
    const {
      features
    } = storeToRefs(meStore);
    const props = __props;

    // Null when there is no seat figure to show at all, so the row can be hidden rather than
    // printing a label with nothing beside it. A genuine 0 is a value and still renders.
    // Keeps the original `currentPaidSeats || seats` precedence.
    const seatCount = computed(() => {
      const plan = props.subscription?.plan;
      if (!plan) return null;
      return (plan.currentPaidSeats || plan.seats) ?? null;
    });
    const subscriptionSummaryState = reactive({
      saving: false,
      validEmail: true,
      editEmail: false,
      subscription: {}
    });
    onMounted(() => {
      subscriptionSummaryState.subscription = props.subscription;
      subscriptionSummaryState.validEmail = props.subscription.email;
      maxioCompanySubscriptionStore.alerts = props.alerts;
    });
    const validEmail = computed(() => {
      return props.subscription.email && props.subscription.email.match(/^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);
    });
    const updateEmail = async () => {
      subscriptionSummaryState.saving = true;
      if (!validEmail.value) {
        subscriptionSummaryState.validEmail = false;
        subscriptionSummaryState.saving = false;
        return;
      }
      await maxioCompanySubscriptionStore.updateSubscriptions({
        email: props.subscription.email
      });
      subscriptionSummaryState.editEmail = false;
      subscriptionSummaryState.saving = false;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("table", _hoisted_1, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[4] || (_cache[4] = _createElementVNode("td", null, "Product", -1)), _createElementVNode("td", null, [_createElementVNode("b", null, _toDisplayString(__props.subscription.product?.label) + " " + _toDisplayString(__props.subscription.scheduledCancellationDate ? '(Pending Cancellation)' : ''), 1)]), _cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1))]), _withDirectives(_createElementVNode("tr", null, [_cache[6] || (_cache[6] = _createElementVNode("td", null, "Plan", -1)), _createElementVNode("td", null, [_createElementVNode("b", null, _toDisplayString(__props.subscription.plan?.label), 1)]), _cache[7] || (_cache[7] = _createElementVNode("td", null, null, -1))], 512), [[_vShow, __props.subscription.plan?.label && __props.subscription?.product?.label != __props.subscription.plan?.label]]), _withDirectives(_createElementVNode("tr", null, [_cache[8] || (_cache[8] = _createElementVNode("td", null, "Deal", -1)), _createElementVNode("td", null, [_createElementVNode("b", null, _toDisplayString(__props.subscription.deal?.description), 1)]), _cache[9] || (_cache[9] = _createElementVNode("td", null, null, -1))], 512), [[_vShow, __props.subscription.deal]]), _withDirectives(_createElementVNode("tr", null, [_cache[10] || (_cache[10] = _createElementVNode("td", null, "Credit", -1)), _createElementVNode("td", null, [_createElementVNode("p", null, [_createElementVNode("b", null, _toDisplayString(_unref(formatCurrency)(__props.subscription.account?.balance)), 1)]), _withDirectives(_createElementVNode("p", null, " Prepaid amount - will be applied to the next subscription renewal ", 512), [[_vShow, __props.subscription.deal]])]), _cache[11] || (_cache[11] = _createElementVNode("td", null, null, -1))], 512), [[_vShow, __props.subscription.account?.balance > 0]]), seatCount.value !== null ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [_cache[12] || (_cache[12] = _createElementVNode("td", null, "Seats (Users)", -1)), _createElementVNode("td", null, [_createElementVNode("b", null, _toDisplayString(seatCount.value), 1), _withDirectives(_createElementVNode("span", null, " - adjusting down to " + _toDisplayString(__props.subscription.plan?.seats) + " seats at next billing cycle (on " + _toDisplayString(_unref(formatDate)(__props.subscription.plan?.periodEnd)) + ")", 513), [[_vShow, __props.subscription.plan?.periodEnd && __props.subscription.plan?.currentPaidSeats > __props.subscription.plan?.seats && !__props.subscription.subscriptionEndDate]])]), _cache[13] || (_cache[13] = _createElementVNode("td", null, null, -1))])) : _createCommentVNode("", true)]), _createElementVNode("tbody", null, [!_unref(features)?.customPricing && __props.subscription.plan?.description ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [_cache[14] || (_cache[14] = _createElementVNode("td", null, "Price", -1)), _createElementVNode("td", _hoisted_4, _toDisplayString(__props.subscription.plan?.description), 1), _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1))])) : _createCommentVNode("", true), __props.subscription.scheduledCancellationDate && __props.subscription.plan?.periodEnd ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [_cache[16] || (_cache[16] = _createElementVNode("td", null, "Cancellation Date", -1)), _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(__props.subscription.plan?.periodEnd)), 1), _cache[17] || (_cache[17] = _createElementVNode("td", null, null, -1))])) : _createCommentVNode("", true), !__props.subscription.scheduledCancellationDate && __props.subscription.plan?.periodEnd ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [_cache[18] || (_cache[18] = _createElementVNode("td", null, "Renewal Date", -1)), _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(__props.subscription.plan?.periodEnd)), 1), _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1))])) : _createCommentVNode("", true), _createElementVNode("tr", null, [_cache[24] || (_cache[24] = _createElementVNode("td", null, "Billing Email", -1)), _createElementVNode("td", null, [_withDirectives(_createElementVNode("b", null, _toDisplayString(__props.subscription.email), 513), [[_vShow, !subscriptionSummaryState.editEmail]]), _withDirectives(_createElementVNode("input", {
        class: "h-10 px-3 border-gray-300 border rounded focus:outline-none focus:shadow-outline focus:ring focus:ring-[rgba(var(--v-theme-primary),0.3)]",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.subscription.email = $event)
      }, null, 512), [[_vShow, subscriptionSummaryState.editEmail], [_vModelText, __props.subscription.email]]), !validEmail.value ? (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[20] || (_cache[20] = [_createElementVNode("span", {
        class: "fa fa-exclamation-triangle px-2"
      }, null, -1), _createElementVNode("span", {
        class: "text-error"
      }, "Invalid email", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("td", null, [_withDirectives(_createVNode(LlSecondaryButton, {
        onClick: _cache[1] || (_cache[1] = $event => subscriptionSummaryState.editEmail = true)
      }, {
        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" Update Email ", -1)]))]),
        _: 1
      }, 512), [[_vShow, !subscriptionSummaryState.editEmail]]), _withDirectives(_createVNode(LlSecondaryButton, {
        class: "mr-2",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => subscriptionSummaryState.editEmail = false, ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }, 512), [[_vShow, subscriptionSummaryState.editEmail]]), _withDirectives(_createVNode(LlSecondaryButton, {
        color: "primary",
        disabled: subscriptionSummaryState.saving,
        onClick: _cache[3] || (_cache[3] = $event => updateEmail())
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("span", null, "Save", 512), [[_vShow, !subscriptionSummaryState.saving]]), _withDirectives(_createElementVNode("span", null, [...(_cache[23] || (_cache[23] = [_createElementVNode("span", {
          class: "fa fa-cog fa-spin"
        }, null, -1), _createTextVNode(" saving... ", -1)]))], 512), [[_vShow, subscriptionSummaryState.saving]])]),
        _: 1
      }, 8, ["disabled"]), [[_vShow, subscriptionSummaryState.editEmail]])])])])]);
    };
  }
};